export default "__VITE_ASSET__CCKIw2ss__"